/**
 * Datalayer related scripts here.
 *
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Export the class reference.
 */
export default class DataLayer {
    /**
     * Cache dom elements for use in the class's methods
     *
     * @return {void}
     */
    cache() {
        this.$variationSelect  = $( '.js-single-product-variation-select' );
    }

    /**
     * Gets cart total elements with ajax.
     *
     * @return {int} Total number of elements in cart.
     */
    addedToCartEvent() {

        // Wait until item has added to cart.
        $( document.body ).on( 'added_to_shopping_cart ', ( event, data ) => {

            let $form         = $( data.form );
            let itemVariantId = 0;

            if( $form.data( 'product-type' ) === 'variation' ) {
                itemVariantId = $( '#js-product-id' ).val();
            }

            const items = [ {
                item_id: $form.data( 'main-product-id' ),
                item_name: $form.data( 'item-name' ),
                item_brand: $form.data( 'brand' ),
                item_variant: this.getVariants(),
                item_variant_id: parseInt( itemVariantId ),
                quantity: parseInt( data.quantity ),
                ...$form.data( 'categories' ),
            } ];

            // Clear the previous ecommerce object.
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "add_to_cart",
                ecommerce: items
            });
        });

    }

    /**
     * Get selected variant values from select fields.
     *
     * @return {string} Variants.
     */
    getVariants() {

        const variations = [];

        if ( ! this.$variationSelect.length ) {
            return variations.toString();
        }

        this.$variationSelect.each( function() {
            variations.push( this.options[this.selectedIndex].text );
        });

        return variations.toString();

    }

    /**
     * Push view_item_list to datalayer from global variable.
     *
     * @return {void}
     */
    viewItemListEvent() {
        if ( typeof viewItemListDataLayerItems !== 'undefined' ) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push( viewItemListDataLayerItems );
        }

    }

    /**
     * Reload cart when product amount has been updated.
     * Otherwise datalayer won't detect new item count.
     * @return {void}
     */
    reloadCart() {
        $( document.body ).on( 'updated_cart_totals', function() {
            location.reload();
        });
    }

    /**
     * Listens Gravity forms confirmation message.
     * Clone view_cart data from datalayer and use same data for send_cart event.
     *
     * @return {void}
     */
    sendCartEvent() {
        /**
         * @param event JS Object | object The Javascript event object.
         * @param formId integer The ID of the form submitted.
         */
        $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {

            let ecommerceData = null;

            if ( dataLayer.length ) {
                dataLayer.forEach( function( item ) {
                    if ( item.event === 'view_cart' ) {
                        ecommerceData = item.ecommerce;
                    }
                });
            }

            if ( ecommerceData ) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: 'send_cart',
                    ecommerce: ecommerceData
                });
            }
        });
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Update product id if product is variation.
        $( document ).on( 'change', '#js-product-id', ( e ) => {
            this.$productId = e.value;
        });
    }

    /**
     * Run when the document is ready.
     *
     * @return {void}
     */
    docReady() {
        this.cache();
        this.events();
        this.addedToCartEvent();
        this.viewItemListEvent();
        this.reloadCart();
        this.sendCartEvent();
    }
}
